<template>
  <div ref="trend" class="trend" @mouseenter="enter()" @mouseleave="leave()">
    <div class="tab" :class="{'typeBlue': styleType == 'typeBlue', 'typeStrong': styleType == 'typeStrong'}">
      <a
        class="home_tab"
        v-for="(item,i) in selectArr"
        :key="i"
        :class="{'home_tab_actived':selectIndex==i}"
        @click.stop="handleItem(i)"
      >{{item.name}}</a>
    </div>
    <div class="chart" ref="chart" v-show="!hideChart"></div>
  </div>
</template>

<script>
import getOpt from './chartOptTrend.js'
import { unwarp } from '@/utils/tools.js'

export default {
  components: {},
  props: ['matrix', 'x', 'y'],
  data() {
    return {
      styleType: '',
      customerId: this.$store.state.customerId,
      chart: null,
      selectIndex: 0,
      selectArr: [{ name: '时' }, { name: '日' }, { name: '月' }],
      pmData: {
        xData: [],
        y1Data: [],
        y2Data: []
      },
      unit: 1,
      setTime1: null,
      setTimeAutoMove: null,
      dataBox: {},
      aqiData: [],
      hideChart: false
    }
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType
    }
    // hideChart() {
    //   return this.$store.state.emissionSwitch == 'close' && this.$store.state.videoSquareSwitch == 'close'
    // }
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal
        this.typeChange()
      },
      deep: true
    },
    '$store.state.emissionSwitch'(newVal) {
      this.hideChart = newVal == 'open'
      if (!this.hideChart) {
        this.typeChange()
        this.autoChange()
      }
    },
    '$store.state.videoSquareSwitch'(newVal) {
      this.hideChart = newVal == 'open'
      if (newVal == 'close') {
        this.typeChange()
        this.autoChange()
      }
    }
    // hideChart(newVal) {
    //   console.log(newVal)
    // }
  },
  created() {
    this.styleType = this.$store.state.styleType
    if (this.customerId == 42) {
      this.pmData.aqi = []
    }
  },
  mounted() {
    // this.getData();

    let w = $(this.$refs.trend).outerWidth()
    let h = $(this.$refs.trend).outerHeight()

    this.$emit('componentInit', {
      w: w,
      h: h,
      matrixType: this.matrix,
      x: this.x,
      y: this.y
    })
    $('.chart div:first').addClass('bug');
    $('.bug').css({width:'560px !important'});
    this.typeChange()
    this.autoChange()
    // this.is42AQI()
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1)
      this.setTime1 = null
    }
    if (this.setTimeAutoMove) {
      clearTimeout(this.setTimeAutoMove)
    }
    if (this.setTimeCheck) {
        clearTimeout(this.setTimeCheck);
      }
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    is42AQI() {
      let aqiUrl = CONFIG.requestName + '/homePage/findAllHistoryByTypeAQI'
      return this.$apiUtils.get(aqiUrl, {
        customerId: this.customerId,
        type: this.unit
      })
    },
    autoChange() {
      if (this.setTimeCheck) {
        clearTimeout(this.setTimeCheck);
      }
      if (this.setTimeAutoMove) {
        clearTimeout(this.setTimeAutoMove)
      }
      // if (this.customerId != 42) return //先注释，后期上线解除
      // return.setTimeCh.setTimeCheck
      ////console.log("this.dataBox", this.dataBox);
      this.unit += 1
      if (this.unit > 3) {
        this.unit = 1
      }
      this.selectIndex = this.unit - 1
      if (this.dataBox[this.unit] && this.dataBox[this.unit]['xData'] && this.dataBox[this.unit]['xData'].length) {
        if (this.chart) {
          this.chart.dispose()
          this.chart = null
        }
        this.chart = echarts.init(this.$refs.chart)
        $('.chart div:first').addClass('bug');
        unwarp(this.chart).setOption(getOpt(this.dataBox[this.unit], (this.unit == 2 || this.unit == 3) && this.customerId == 42))
      } else {
        this.setTimeCheck = setTimeout(() => {
          this.getData()
        }, 500)
      }
      this.setTimeAutoMove = setTimeout(() => {
        this.autoChange()
      }, 1000 * 8)
    },
    typeChange() {
      if (this.styleType == 'typeGreen') {
        this.$nextTick(() => {
          $('.trend .tab').css({ 'padding-top': '20px', height: '25px' })
        })
      } else if (this.styleType == 'typeDark') {
        this.$nextTick(() => {
          $('.trend .tab').css({ 'padding-top': 'initial', height: 'initial' })
        })
      }
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      if (this.customerId != 42) {
        this.getData()
      }
    },
    enter() {
      if (this.setTimeAutoMove) {
        clearTimeout(this.setTimeAutoMove)
      }
    },
    leave() {
      if (this.setTimeAutoMove) {
        clearTimeout(this.setTimeAutoMove)
      }
      this.setTimeAutoMove = setTimeout(() => {
        this.autoChange()
      }, 30000)
    },
    handleItem(index) {
      this.unit = index + 1
      this.selectIndex = index
      this.getData()
    },
    async getData() {
      let _this = this
      if (this.setTime1) {
        clearTimeout(this.setTime1)
        this.setTime1 = null
      }
      this.pmData = {
        xData: [],
        y1Data: [],
        y2Data: []
      }
      if (this.customerId == 42) {
        this.pmData = {
          xData: [],
          y1Data: [],
          y2Data: [],
          aqi: []
        }
      }
      let findAllHistoryByType = CONFIG.requestName + this.$apiOpt.findAllHistoryByType
      let data = await _this.$apiUtils.get(findAllHistoryByType, {
        customerId: _this.customerId,
        type: _this.unit
      })

      if (_this.customerId === 42 && (_this.unit == 2 || _this.unit == 3)) {
        const aqiData = (await _this.is42AQI()) || []
        data &&
          aqiData.length &&
          data.forEach(item => {
            for (let i = 0; i < aqiData.length; i++) {
              if (item.dataTime == aqiData[i].time) {
                item.aqi = aqiData[i].value
              }
            }
          })
      }
      //console.log("----------", data);
      data &&
        data.forEach((x, index) => {
          let { x_data, dataTime, pm10, pm25, aqi } = x
          if (dataTime && dataTime.indexOf(' ') != -1) {
            dataTime = dataTime.split(' ')[1]
          }
          this.pmData.xData.push(dataTime)
          this.pmData.y1Data.push(pm10)
          this.pmData.y2Data.push(pm25)
          this.pmData.aqi && this.pmData.aqi.push(aqi)
        })
      //console.log("this.pmData", this.pmData);
      this.dataBox[this.unit] = this.pmData
      //console.log("this.dataBox111111111", this.dataBox);
      this.$nextTick(() => {
        try {
          if (this.chart) {
            this.chart.dispose()
            this.chart = null
          }
          this.chart = echarts.init(this.$refs.chart);
          unwarp(_this.chart).setOption(getOpt(_this.pmData, (_this.unit == 2 || _this.unit == 3) && _this.customerId == 42))
        } catch (err) {
          // //console.log(err);
        }
      })
      this.setTime1 = setTimeout(() => {
        this.getData()
      }, 1000 * 60 * 5)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.trend {
  width: 600px;
  height: 250px;
  .tab {
    justify-content: flex-end;
    z-index: 1;
    display: flex;
  }
  .typeBlue {
    .home_tab {
      width: 56px;
      height: 26px;
      background: url('./img/tab_default.png') no-repeat;
      background-size: 100% 100%;
      line-height: 26px;
    }
    .home_tab_actived {
      width: 56px;
      height: 26px;
      background: url('./img/tab_active.png') no-repeat;
      background-size: 100% 100%;
      line-height: 26px;
    }
  }
  .typeStrong {
    .home_tab {
      width: 51px;
      height: 27px;
      background: url('./img/tab_default_strong.png') no-repeat;
      background-size: 100% 100%;
      line-height: 26px;
    }
    .home_tab_actived {
      width: 51px;
      height: 27px;
      background: url('./img/tab_active_strong.png') no-repeat;
      background-size: 100% 100%;
      line-height: 26px;
    }
  }
  .chart {
    width: 560px !important;
    height: 180px !important;
    margin-top: 20px;
    position: relative;
    :deep(.bug) {
     width: 560px !important;
    }
  }

}


</style>
